const ROUTER = {
  MESSAGE: '/message',
  DEEPLINK_LIST: '/deeplink-list',
  DEFINE_LOCATION: '/define-location',
  SCHEDULE: '/schedule',
  REQUEST: '/request',
  PERSONAL_DATA: '/personal-data',
  ONEDOC: '/onedoc',
  SUMMARY: '/summary',
  CANCELLATION: '/cancellation',
  RESCHEDULE: '/reschedule',
  ROOT: 'https://www.mercedes-benz.',
  VMOS: '/passengercars/test-drive.html',
};

const APPLICATION_URL = {
  NEW_CUSTOMER_JOURNEY: 'online-testdrive',
  OLD_CUSTOMER_JOURNEY: 'online-testdrive-management',
};

const CONTEXT_OPTIONS = {
  VANS: 'OWVANS',
  CARS: 'OWPC',
};

const TRACKING_ROUTE = {
  ERROR: 'error_page',
  DEFINE_LOCATION: 'define_location_page', // TODO: create this event for tracking define_location page
  SCHEDULE: 'schedule',
  REQUEST: 'request', // TODO: create this event for tracking request page
  PERSONAL_DATA: 'personal_data',
  SUMMARY: 'confirmed',
  CANCELLATION: 'cancellation_start',
  RESCHEDULE: 'rescheduling_start',
};

const CAR_IMAGE = {
  ROTATION: {
    EXPANDED_HEADER: '040',
    COLLAPSED_HEADER: '090',
  },
  WIDTH: {
    EXPANDED_HEADER: 640,
    COLLAPSED_HEADER: 120,
  },
};

const LOCAL_DOMAINS = ['localhost'];

const SPECIFIC_ROUTE = {
  CANCELLATION: 'CANCELLATION',
  DEEPLINK_LIST: 'DEEPLINK_LIST',
  DEFINE_LOCATION: 'DEFINE_LOCATION',
  MESSAGE: 'MESSAGE',
  REQUEST: 'REQUEST',
  RESCHEDULE: 'RESCHEDULE',
  SCHEDULE: 'SCHEDULE',
  SUMMARY: 'SUMMARY',
  VMOS: 'VMOS',
  ONEDOC: 'ONEDOC',
};

const WEIGHT_CATEGORY = {
  HEAVY_WEIGHT: 'HEAVY_WEIGHT',
  LIGHT_WEIGHT: 'LIGHT_WEIGHT',
};

export {
  APPLICATION_URL,
  CAR_IMAGE,
  LOCAL_DOMAINS,
  ROUTER,
  SPECIFIC_ROUTE,
  TRACKING_ROUTE,
  WEIGHT_CATEGORY,
  CONTEXT_OPTIONS,
};
